import { useLocale } from "next-intl";

export const useCurrentLocale = useLocale;
